<template>
  <div class="d-inline-block mr-2 mb-2" :class="[light === true ? 'sz-tag-light' : 'sz-tag']">
    <p
      class="mb-0 px-3 py-1 font-weight-regular sz-secondary-grey--text"
      :class="[light === true ? 'f-12' : 'f-14']"
    >
      {{ text }}
      <v-icon v-if="close" class="close-icon ml-1" :size="12" @click="closeCallback">
        $tagClose
      </v-icon>
    </p>
  </div>
</template>

<script>
export default {
  name: 'TagCustom',
  props: {
    text: {
      required: true,
      type: String
    },
    close: {
      default: false,
      type: Boolean
    },
    light: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    closeCallback() {
      if (this.close === true) {
        this.$emit('callback')
      }
    }
  }
}
</script>
